<template>
    <div class="fibu-buchung-detail">
        <h2>
            Gruppierungskonten für Buchung {{ id }} auswählen
        </h2>
        <div class="fibu-buchung-detail-fields mb-2">
            <FormGroupBuilder
                :fields="ioFields"
                :data="data"
                :refresh="validationRefresh"
            />
            <div class="row">
                <div class="col-2">
                    <div class="row ml-1">
                        <b-button
                            v-if="checkRight('write')"
                            type="submit"
                            class="total-btn mr-1"
                            variant="primary"
                            :disabled="busy"
                            @click="dataProvide"
                        >
                            <template v-if="!busy">Speichern</template>
                            <template v-else>
                                <Spinner small variant="light" />
                            </template>
                        </b-button>
                    </div>
                    <div class="row mt-2 ml-1">
                        <b-button
                            type="cancel"
                            @click="cancelBooking"
                            class="total-btn"
                            variant="outline-secondary"
                        >
                            <template v-if="checkRight('write')">Abbrechen</template>
                            <template v-else>Zurück</template>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Spinner from "@/components/Spinner/Spinner";
import Currency from "@/mixins/Currency/Currency";
import Size from "@/mixins/Size/Size";


const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const FiBuFinanzkontoApi = ApiFactory.get("fibuFinanzkonto");
const FiBuBuchungskontoApi = ApiFactory.get("fibuBuchungskonto");
const FiBuZuschusskontoApi = ApiFactory.get("fibuZuschusskonto");
const FiBuRuecklagenkontoApi = ApiFactory.get("fibuRuecklagenkonto");
const FiBuCategoryApi = ApiFactory.get("fibuCategory");
const FiBuVerwendungszweckApi = ApiFactory.get("fibuVerwendungszweck");
const FiBuBuchungsstapelApi = ApiFactory.get("fibuBuchungsstapel");

export default {
    name: "FiBuBuchungGruppierungskonten",
    props: ["id"],
    mixins: [Toaster, Rights, Validation, Currency, Size],
    components: {
        FormGroupBuilder,
        Spinner
    },
    data() {
        return {
            ioFields: {
                id: {
                    key: "id",
                    label: "ID",
                    disabled: true
                },
                datum: {
                    key: "datum",
                    label: "Buchungsdatum",
                    type: "date",
                    disabled: true
                },
                verwendungszweck: {
                    key: "verwendungszweck",
                    label: "Verwendungszweck",
                    type: "text",
                },
                zuschusskonto_id: {
                    key: "zuschusskonto_id",
                    label: "Zuschusskonto",
                    type: "filteredselect",
                    options: []
                },
                ruecklagenkonto_id: {
                    key: "ruecklagenkonto_id",
                    label: "Rücklagenkonto",
                    type: "filteredselect",
                    options: []
                },
            },
            filter: {},
            data: {},
            busy: false,
            zuschusskonto: {
                busy: false,
                items: [],
                options: []
            },
            ruecklagenkonto: {
                busy: false,
                items: [],
                options: []
            },
        };
    },
    created() {
        this.fetch();
        this.fetchZuschusskonto();
        this.fetchRuecklagenkonto();
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await FiBuBuchungApi.getSingle(this.id);
            if (response.ok) {
                this.registerRights(response);
                this.cleanPayload(response.json);
                const data = response.json;
                this.data = data;
            }
            this.busy = false;
        },
        async fetchZuschusskonto() {
            this.zuschusskonto.busy = true;
            const response = await FiBuZuschusskontoApi.get();
            if (response.ok) {
                this.zuschusskonto.items = response.json.collection;
                const options = [
                    {
                        text: 'kein Zuschusskonto',
                        value: null,
                    },
                    ...response.json.collection.map(item => {
                        return {
                            text: item.text,
                            value: item.id
                        };
                    })
                ]
                this.zuschusskonto.options = options;
                this.ioFields.zuschusskonto_id.options = options;
            }
            this.zuschusskonto.busy = false;
        },
        async fetchRuecklagenkonto() {
            this.ruecklagenkonto.busy = true;
            const response = await FiBuRuecklagenkontoApi.get();
            if (response.ok) {
                this.ruecklagenkonto.items = response.json.collection;
                const options = [
                    {
                        text: 'kein Ruecklagenkonto',
                        value: null,
                    },
                    ...response.json.collection.map(item => {
                        return {
                            text: item.text,
                            value: item.id
                        };
                    })
                ]
                this.ruecklagenkonto.options = options;
                this.ioFields.ruecklagenkonto_id.options = options;
            }
            this.ruecklagenkonto.busy = false;
        },
        async dataProvide() {
            this.busy = true;

            var response = await FiBuBuchungApi.putGruppierungskonten(this.id, {...this.data});

            if (response.ok) {
                this.cleanValidationData(this.ioFields);

                this.$emit("update");

                const pages = this.$store.getters.getPages;

                if(pages.fibu_kontenblaetter.editBuchung) {
                    this.$router.push({
                        path: `/fibu/kontenblaetter`
                    });
                } else {
                    this.$router.push({
                        path: `/fibu/buchung`,
                        hash: `#${response.json.collection[0]}`
                    });
                }

                this.makeToast(
                    'Buchung gespeichert',
                    'Die von Ihnen angelegte Buchung wurde erfolgreich in der Datenbank gespeichert',
                    'success'
                );
            } else {
                this.handleValidationData(response, this.ioFields);
            }
            this.busy = false;
        },
        cancelBooking() {
            this.$router.push({
                path: `/fibu/buchung`,
                hash: `${this.id}`
            });
        },
        cleanPayload(json) {
            Object.keys(json).forEach(key => {
                if (key.startsWith("_")) {
                    delete json[key];
                }
            });
        },
    }
};
</script>
